import * as actions from './actions'

const initState = {
    apiKeys: null,
    apiKey: null
}

export default function reducer(state = initState, action) {
    switch (action.type) {
        case actions.API_KEYS_SUCCESS:
            return {
                ...state,
                ...{
                    apiKeys: action.apiKeys
                }
            }
        case actions.API_KEY_SUCCESS:
            return {
                ...state,
                ...{
                    apiKey: action.apiKey
                }
            }
        default:
            return state
    }
}
